/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="selfCheckInKioskSettings.module.ts" />

module Meevo.Plugins.SelfCheckInKioskSettings {
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import ISelectItem = Meevo.Model.ISelectItem;
    import IStorageFile = Meevo.Model.IStorageFile;
    import ICustomDataResource = Meevo.Model.ICustomDataResource;
    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;

    export interface ISelfCheckInKioskSettingsModel {
        clientCheckinThreshold: string;
        checkInAllServices: boolean;
        messageTimeout: number;
        greetingMessage: string;
        successfulCheckinMessage: string;
        unsuccessfulCheckinMessage: string;
        groupEnum: number;

        checkinBusinessLogo: ICustomDataResource;
        promotionalContent1: ICustomDataResource;
        promotionalContent2: ICustomDataResource;
        promotionalContent3: ICustomDataResource;
        promotionalContents: {
            accentColor: string;
            advertisementImageUrl: string;
            description: string;
            displayName: string;
        }[];

        settings?: {
            id: number;
            displayName: string;
            effectiveValue: number;
            settableLevels: number
        }[];

        checkinPromotionalContent1Description?: string;
        checkinPromotionalContent1Title?: string;
        checkinPromotionalContent2Description?: string;
        checkinPromotionalContent2Title?: string;
        checkinPromotionalContent3Description?: string;
        checkinPromotionalContent3Title?: string;
        allowClientToUpdateProfile: boolean;
        clientCheckinLateThreshold?: number;
        notSubmittedFormsPreventCheckinMessage?: string;
        preventCheckinIfNotSubmittedForms?: boolean;
        promptUnsubmittedForms?: boolean;
    }

    export class SelfCheckInKioskSettingsController extends ShortCutsStateManagerController {

        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.common.DataService',
            'meevo.components.common.IdentityService',
            'meevo.AppSettings',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
        ];

        public model: ISelfCheckInKioskSettingsModel = <ISelfCheckInKioskSettingsModel>{};

        public allowCheckInOptions: ISelectItem<number>[] = [
            {label: '00m', value: 0},
            {label: '15m', value: 15},
            {label: '30m', value: 30},
            {label: '45m', value: 45},
            {label: '1h', value: 60},
            {label: '2h', value: 120},
            {label: '3h', value: 180},
            {label: '4h', value: 240},
            {label: '5h', value: 300},
            {label: '6h', value: 360},
            {label: '7h', value: 420},
            {label: '8h', value: 480},
        ];

        public allowLateCheckInOptions: ISelectItem<number>[] = [
            {label: '00m', value: 0},
            {label: '05m', value: 5},
            {label: '10m', value: 10},
            {label: '15m', value: 15},
            {label: '20m', value: 20},
            {label: '25m', value: 25},
            {label: '30m', value: 30},
        ];
        public messageTimeoutOptions: ISelectItem<number>[] = [
            {label: '15', value: 15},
            {label: '30', value: 30},
            {label: '40', value: 40},
        ];

        public baseSecurityKey = SecurityKeys.BUSINESSINFO_SELFCHECKINKIOSKSETTINGS_TAB_MAIN;
        public editSecurityKey = this.baseSecurityKey + SecurityParts.KEY_PART_WRITE;
        public isDisabledClientIntakeForm = false;

        protected shortCutGroup: { [key: number]: IShortCutGroup };

        private backUp: ISelfCheckInKioskSettingsModel;
        private _mode: MaintenanceFormState;

        public get isEditing(): boolean {
            return this.mode === MaintenanceFormState.Editing;
        }

        public get isReadonly(): boolean {
            return this.mode === MaintenanceFormState.Readonly;
        }

        public get mode(): Meevo.Model.MaintenanceFormState {
            return this._mode;
        }

        public get isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        public get isSingleLocation(): boolean {
            return this.identityService.isSingleLocation();
        }

        constructor(
            protected $scope: ng.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IStateService,
            protected shortCutsService: IShortCutsService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected appSettings: Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
        ) {
            super($scope, $state, shortCutsService);

            this._mode = MaintenanceFormState.Readonly;
            this.setShortcuts();
            this.getData();
            this.securityService.checkModuleAccess(SecurityKeys.DATA_CLIENTINTAKEFORM + SecurityParts.KEY_PART_READ)
                .then((securityAccess) => {
                    this.isDisabledClientIntakeForm = securityAccess !== Meevo.Model.SecurityAccessEnum.Grant;
                });
        }

        public closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        public save(): void {
            this._mode = MaintenanceFormState.Readonly;

            this.busyService.start();
            this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.selfCheckInKioskSettings}`, 'POST', this.model)
                .then((res) => {
                    this.model = angular.copy(res.data);
                    this.setBackUp();
                })
                .finally(() => this.busyService.stop());
        }

        public edit(): void {
            this._mode = MaintenanceFormState.Editing;
        }

        public cancel(): void {
            this.rollbackChanges();
            this._mode = MaintenanceFormState.Readonly;
        }

        public getImageUrl(imageData: IStorageFile, url: any): any {
            if (imageData) {
                url = this.searchFile(imageData, 'Source', url);
            }

            return url;
        }

        private getData(): angular.IPromise<any> {
            this.busyService.start();

            return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.selfCheckInKioskSettings}`, 'GET', null)
                .then((res) => {
                    this.model = angular.copy(res.data);
                    this.setBackUp();
                })
                .finally(() => this.busyService.stop());
        }

        private setShortcuts(): void {
            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.edit();
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.save();
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.cancel();
                    }
                }])
            };
        }

        private setBackUp(): void {
            this.backUp = angular.copy(this.model);
        }

        private rollbackChanges(): void {
            this.model = angular.copy(this.backUp);
        }

        private searchFile(filedata: IStorageFile, searchKey: string, defaultUrl: string): string {
            let filedetails = filedata;
            let fileUrl = defaultUrl;


            if (filedetails
                && filedetails.meevoFile
                && filedetails.meevoFile.files
                && filedetails.meevoFile.files.length > 0) {

                filedetails.meevoFile.files.forEach((setting) => {
                    if (setting.key === searchKey) {
                        fileUrl = setting.fileUrl;
                    }
                });
            }

            return fileUrl;
        }
    }

    angular.module('meevo.plugins.selfCheckInKioskSettings')
        .controller('meevo.plugins.selfCheckInKioskSettings.SelfCheckInKioskSettingsController', SelfCheckInKioskSettingsController);
}
